import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvoicesRoutingModule } from './invoices-routing.module';
import { InvoiceListComponent } from './invoices-list/invoice-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { InvoiceListViewComponent } from './invoices-list/invoice-list-view/invoice-list-view.component';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { InvoiceCardViewComponent } from './invoices-list/invoice-card-view/invoice-card-view.component';
import { InvoiceListFilterComponent } from './invoices-list/invoice-list-filter.component.ts/invoice-list-filter.component';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FormsModule } from '@angular/forms';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceListContractComponent } from './invoices-list/invoice-list-contract/invoice-list-contract.component';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  imports: [
    CommonModule,
    InvoicesRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    FormsModule,
    PipeModule,
    ClipboardModule,
    NgbModule,
    InputsModule,
  ],
  declarations: [
    InvoiceListComponent,
    InvoiceListViewComponent,
    InvoiceCardViewComponent,
    InvoiceListFilterComponent,
    InvoiceDetailComponent,
    InvoiceListContractComponent,
  ],
})
export class InvoicesModule {}
